import { AuthGuard } from '@infodocs/shared/guards/auth.guard';
import {
	PrivatePagesWrapperComponent
} from '@infodocs/shared/components/private-pages-wrapper/private-pages-wrapper.component';
import {
	PublicPagesWrapperComponent
} from '@infodocs/shared/components/public-pages-wrapper/public-pages-wrapper.component';

export const companyRoutes = [
	{
		path: '',
		canActivate: [AuthGuard],
		component: PrivatePagesWrapperComponent,
		children: [
			{
				path: '',
				pathMatch: 'full',
				loadComponent: () => import('../portfolio/portfolio-experience-redirect.component').then(m => m.PortfolioExperienceRedirectComponent),
			},
			{
				path: 'xero-callback',
				loadComponent: () => import('@infodocs/account/pages/xero-callback-page/xero-callback-page.component').then(m => m.XeroCallbackPageComponent),
			},
			{
				path: 'profile/:companyId',
				loadComponent: () => import('./pages/dashboard-page/dashboard-page.component').then(m => m.DashboardPageComponent),
				children: [
					{
						path: '',
						pathMatch: 'full',
						loadComponent: () => import('./pages/dashboard-page/dashboard-tab/dashboard-tab.component').then(m => m.DashboardTabComponent)
					},
					{
						path: 'reinstate',
						loadComponent: () => import('./pages/dashboard-page/reinstate-tab/reinstate-tab.component').then(m => m.ReinstateTabComponent)
					},
					{
						path: 'company',
						loadComponent: () => import('./pages/dashboard-page/company-tab/company-tab.component').then(m => m.CompanyTabComponent),
						children: [
							{
								path: '',
								pathMatch: 'full',
								redirectTo: 'information'
							},
							{
								path: 'information',
								loadComponent: () => import('./pages/dashboard-page/company-tab/company-information-tab/company-information-tab.component').then(m => m.CompanyInformationTabComponent),
							},
							{
								path: 'admin',
								loadComponent: () => import('./pages/dashboard-page/company-tab/company-admin-tab/company-admin-tab.component').then(m => m.CompanyAdminTabComponent),
							},
							{
								path: 'dates',
								loadComponent: () => import('./pages/dashboard-page/company-tab/diary-dates-tab/diary-dates-tab.component').then(m => m.DiaryDatesTabComponent),
							},
							{
								path: 'details',
								loadComponent: () => import('./pages/dashboard-page/company-tab/contact-details-tab/contact-details-tab.component').then(m => m.ContactDetailsTabComponent),
							},
							{
								path: 'access',
								loadComponent: () => import('./pages/dashboard-page/company-tab/company-manage-tab/company-manage-tab.component').then(m => m.CompanyAccessTabComponent),
							},
							{
								path: 'integrations',
								loadComponent: () => import('./pages/dashboard-page/company-tab/integrations-tab/integrations-tab.component').then(m => m.IntegrationsTabComponent),
							}
						]
					},
					// TODO: [after rebuild] create dedicated /members route
					{
						path: 'directors',
						loadComponent: () => import('./pages/dashboard-page/directors-tab/directors-tab.component').then(m => m.DirectorsTabComponent),
						children: [
							{
								path: 'list',
								loadComponent: () => import('./pages/dashboard-page/directors-tab/directors-list-tab/directors-list-tab.component').then(m => m.DirectorsListTabComponent),
							},
							{
								path: 'interest',
								loadComponent: () => import('./pages/dashboard-page/directors-tab/members-interest-tab/members-interest-tab.component').then(m => m.MembersInterestTabComponent),
							},
							{
								path: '',
								pathMatch: 'full',
								redirectTo: 'list'
							},
							{
								path: ':directorshipId',
								loadComponent: () => import('./pages/dashboard-page/directors-tab/director-tab/director-tab.component').then(m => m.DirectorTabComponent),
								children: [
									{
										path: '',
										pathMatch: 'full',
										redirectTo: 'information'
									},
									{
										path: 'information',
										loadComponent: () => import('./pages/dashboard-page/directors-tab/director-tab/director-information-tab/director-information-tab.component').then(m => m.DirectorInformationTabComponent),
									},
									{
										path: 'appointments',
										loadComponent: () => import('./pages/dashboard-page/directors-tab/director-tab/director-appointments-tab/director-appointments-tab.component').then(m => m.DirectorAppointmentsTabComponent),
									},
									{
										path: 'shareholdings',
										loadComponent: () => import('./pages/dashboard-page/directors-tab/director-tab/director-shareholdings-tab/director-shareholdings-tab.component').then(m => m.DirectorShareholdingsTabComponent),
									},
									{
										path: 'details',
										loadComponent: () => import('./pages/dashboard-page/directors-tab/director-tab/director-details-tab/director-details-tab.component').then(m => m.DirectorDetailsTabComponent),
									}
								]
							}
						]
					},
					{
						path: 'shareholders',
						loadComponent: () => import('./pages/dashboard-page/shareholders-tab/shareholders-tab.component').then(m => m.ShareholdersTabComponent),
						children: [
							{
								path: 'list',
								loadComponent: () => import('./pages/dashboard-page/shareholders-tab/shareholders-list-tab/shareholders-list-tab.component').then(m => m.ShareholdersListTabComponent),
							},
							{
								path: 'transactions',
								loadComponent: () => import('./pages/dashboard-page/shareholders-tab/share-transactions-tab/share-transactions-tab.component').then(m => m.ShareTransactionsComponent),
							},
							{
								path: 'certificates',
								loadComponent: () => import('./pages/dashboard-page/shareholders-tab/share-certificates-tab/share-certificates-tab.component').then(m => m.ShareCertificatesComponent),
							},
							{
								path: 'shareclasses',
								loadComponent: () => import('./pages/dashboard-page/share-classes-tab/share-classes-tab.component').then(m => m.ShareClassesTabComponent),
							},
							{
								path: '',
								pathMatch: 'full',
								redirectTo: 'list'
							},
							{
								path: ':shareholdingId',
								loadComponent: () => import('./pages/dashboard-page/shareholders-tab/shareholder-tab/shareholder-tab.component').then(m => m.ShareholderTabComponent),
								children: [
									{
										path: '',
										pathMatch: 'full',
										redirectTo: 'information'
									},
									{
										path: 'information',
										loadComponent: () => import('./pages/dashboard-page/shareholders-tab/shareholder-tab/shareholder-information-tab/shareholder-information-tab.component').then(m => m.ShareholderInformationTabComponent),
									},
									{
										path: 'appointments',
										loadComponent: () => import('./pages/dashboard-page/shareholders-tab/shareholder-tab/shareholder-appointments-tab/shareholder-appointments-tab.component').then(m => m.ShareholderAppointmentsTabComponent),
									},
									{
										path: 'shareholdings',
										loadComponent: () => import('./pages/dashboard-page/shareholders-tab/shareholder-tab/shareholder-shareholdings-tab/shareholder-shareholdings-tab.component').then(m => m.ShareholderShareholdingsTabComponent),
									},
									{
										path: 'details',
										loadComponent: () => import('./pages/dashboard-page/shareholders-tab/shareholder-tab/shareholder-details-tab/shareholder-details-tab.component').then(m => m.ShareholderDetailsTabComponent),
									}
								]
							}
						]
					},
					{
						path: 'owners',
						loadComponent: () => import('./pages/dashboard-page/owners-tab/owners-tab.component').then(m => m.OwnersTabComponent),
						children: [
							{
								path: 'list',
								loadComponent: () =>
									import('./pages/dashboard-page/owners-tab/owners-list-tab/owners-list-tab.component').then(
										m => m.OwnersListTabComponent
									),
							},
							{
								path: '',
								pathMatch: 'full',
								redirectTo: 'list',
							},
						],
					},
					{
						path: 'documents',
						loadComponent: () => import('./pages/dashboard-page/documents-tab/documents-tab.component').then(m => m.DocumentsTabComponent),
						children: [
							{ path: '', pathMatch: 'full', redirectTo: 'list' },
							{
								path: 'list',
								loadComponent: () => import('./pages/dashboard-page/documents-tab/documents-list-tab/documents-list-tab.component').then(m => m.DocumentsListTabComponent)
							},
							{
								path: 'library',
								loadComponent: () => import('./pages/dashboard-page/documents-tab/template-library-tab/template-library-tab.component').then(m => m.TemplateLibraryTabComponent),
								children: [
									{
										path: '',
										pathMatch: 'full',
										loadComponent: () => import('./pages/dashboard-page/documents-tab/template-library-tab/template-library-select-tab/template-library-select-tab.component').then(m => m.TemplateLibrarySelectTabComponent),
									},
									{ path: 'word', loadComponent: () => import('./pages/dashboard-page/documents-tab/template-library-tab/template-library-word-tab/template-library-word-tab.component').then(m => m.TemplateLibraryWordTabComponent) },
									{ path: 'pdf', loadComponent: () => import('./pages/dashboard-page/documents-tab/template-library-tab/template-library-pdf-tab/template-library-pdf-tab.component').then(m => m.TemplateLibraryPdfTabComponent) },
								]
							}
						]
					}
				]
			}
		]
	},
	{
		path: ':registrationNumber',
		loadComponent: () => import('@infodocs/company/pages/public-company-profile/public-company-profile.component')
	},
	{
		path: '**',
		component: PublicPagesWrapperComponent,
		children: [
			{
				path: '**',
				loadComponent: () => import('../public/pages/error-page/error-page.component').then(m => m.ErrorPageComponent),
				data: { headerType: 'withLogin' },
			},
		],
	},
] satisfies import('@angular/router').Routes;
